// 每日瓜料 - 首页展示数据（占位内容数据源，后续可接后端）

export const CATEGORIES = [
  { key: "all", label: "全部瓜田" },
  { key: "ta", label: "塌房" },
  { key: "fan", label: "翻车" },
  { key: "lian", label: "恋情" },
  { key: "zong", label: "综艺" },
  { key: "drama", label: "新剧" },
  { key: "music", label: "音乐" },
];

export const TICKER_NEWS = [
  "刚刚：演员沈以沫工作室深夜发声，否认网传解约传闻",
  "快讯：偶像组合WEEK8队长被拍到深夜现身排练室，疑似备战回归",
  "现场：主持程之涵综艺录制现场失控落泪，原因暂未公开",
  "独家：歌手林小满被目击与音乐制作人共进晚餐，恋情疑曝光",
  "路透：古装新剧《长安夜雪》开机，主演造型遭网友热评",
  "热榜：金像奖红毯造型盘点，多位艺人造型师成热议焦点",
];

export const HERO_STORY = {
  category: "刚刚爆",
  categoryKey: "fan",
  time: "2小时前",
  title: "年度颁奖礼红毯名场面不断：谁凭造型封神，谁又惨遭滑铁卢？",
  summary:
    "颁奖季首场大秀刚刚落幕，从压轴礼服到妆发细节都成了网友热议焦点。有人凭一套高定火速出圈，也有人因造型师的小失误被吐槽一整晚。这一夜的瓜，够吃好几天。",
  heat: "324万热度",
  image:
    "https://readdy.ai/api/search-image?query=cinematic%20entertainment%20awards%20red%20carpet%20backstage%20scene%20with%20glowing%20amber%20spotlights%20and%20warm%20coral%20lighting%2C%20dramatic%20silhouette%20of%20celebrity%20in%20flowing%20elegant%20gown%2C%20editorial%20magazine%20photography%2C%20shallow%20depth%20of%20field%2C%20premium%20high%20contrast%20atmosphere%20with%20bokeh%20lights%2C%20moody%20and%20glamorous%20composition&width=1600&height=900&seq=gd-hero-1&orientation=landscape",
};

export interface FeedItem {
  id: number;
  categoryKey: string;
  category: string;
  tag: string;
  title: string;
  summary: string;
  time: string;
  hot: string;
  views: string;
  image: string;
  isHot?: boolean;
}

export const FEED_ITEMS: FeedItem[] = [
  {
    id: 1,
    categoryKey: "ta",
    category: "塌房",
    tag: "最新",
    title: "男团成员深夜被拍私联，经纪人紧急回应称只是普通朋友聚餐",
    summary:
      "视频画面显示该成员凌晨与多名素人并肩走出餐厅，全程谈笑。粉丝连夜考古后，质疑声越来越大，公司暂时未发正式声明。",
    time: "25分钟前",
    hot: "火",
    views: "86万",
    image:
      "https://readdy.ai/api/search-image?query=night%20paparazzi%20street%20scene%20young%20male%20celebrity%20leaving%20restaurant%20at%20midnight%20wearing%20mask%20and%20cap%2C%20warm%20street%20lamp%20lighting%20with%20slight%20grain%2C%20candid%20news%20photography%20style%2C%20shallow%20focus%20on%20subject%2C%20editorial%20journalistic%20mood&width=800&height=500&seq=gd-feed-1&orientation=landscape",
  },
  {
    id: 2,
    categoryKey: "lian",
    category: "恋情",
    tag: "独家",
    title: "女主播陈一一与神秘男子同逛商场，牵手瞬间被镜头捕捉",
    summary:
      "两人在甜品店停留近一小时，动作亲昵自然。男方身份暂未公开，有网友猜测是圈外高管，陈一一本人尚未回应。",
    time: "48分钟前",
    hot: "热",
    views: "61万",
    image:
      "https://readdy.ai/api/search-image?query=silhouette%20of%20a%20couple%20walking%20closely%20together%20through%20a%20modern%20mall%20at%20dusk%2C%20warm%20golden%20interior%20lights%20bokeh%2C%20romantic%20candid%20moment%2C%20editorial%20lifestyle%20photography%20with%20soft%20warm%20tones%2C%20cinematic%20and%20subtle&width=800&height=500&seq=gd-feed-2&orientation=landscape",
  },
  {
    id: 3,
    categoryKey: "fan",
    category: "翻车",
    tag: "刚刚",
    title: "音乐节现场歌手忘词又跑调，台下观众齐声跟唱救场被狂赞",
    summary:
      "面对突发状况，主办方与歌迷默契合唱将场面救回。事后歌手发文自嘲，网友一边调侃一边心疼，话题冲上热榜前五。",
    time: "1小时前",
    hot: "爆",
    views: "132万",
    image:
      "https://readdy.ai/api/search-image?query=open%20air%20music%20festival%20stage%20at%20night%20with%20crowd%20silhouettes%20and%20singer%20holding%20microphone%2C%20warm%20amber%20and%20coral%20stage%20lights%2C%20energetic%20live%20performance%20atmosphere%2C%20editorial%20concert%20photography%2C%20slight%20motion%20blur%20conveying%20lively%20crowd&width=800&height=500&seq=gd-feed-3&orientation=landscape",
  },
  {
    id: 4,
    categoryKey: "drama",
    category: "新剧",
    tag: "路透",
    title: "古装大戏《长安夜雪》开机照流出，服化道质感获业内点赞",
    summary:
      "从曝光的片场照看，造型团队对配色与布料颇为考究。女主定妆照尚未发布，但路透中的场景布置已让剧粉十分期待。",
    time: "2小时前",
    hot: "热",
    views: "43万",
    image:
      "https://readdy.ai/api/search-image?query=elegant%20ancient%20chinese%20costume%20drama%20film%20set%20with%20traditional%20architecture%2C%20flowing%20silk%20robes%20hanging%2C%20warm%20paper%20lantern%20lighting%2C%20behind%20the%20scenes%20production%20stills%2C%20rich%20textured%20fabrics%2C%20editorial%20period%20film%20aesthetic%20with%20soft%20golden%20tones&width=800&height=500&seq=gd-feed-4&orientation=landscape",
  },
  {
    id: 5,
    categoryKey: "zong",
    category: "综艺",
    tag: "repo",
    title: "新综艺《今天不营业》录制repo出炉，嘉宾互怼场面过于真实",
    summary:
      "现场观众透露，几位常驻嘉宾从开场就火花四溅，导演多次笑到叫停。节目组放话正片只剪真实素材，不搞套路剧本。",
    time: "3小时前",
    hot: "热",
    views: "37万",
    image:
      "https://readdy.ai/api/search-image?query=colorful%20reality%20variety%20show%20studio%20set%20behind%20the%20scenes%20with%20bright%20decorative%20lights%20and%20cameras%2C%20empty%20chairs%20and%20lounge%20area%2C%20warm%20playful%20production%20atmosphere%2C%20editorial%20television%20photography%20with%20lively%20saturated%20yet%20soft%20tones&width=800&height=500&seq=gd-feed-5&orientation=landscape",
  },
  {
    id: 6,
    categoryKey: "music",
    category: "音乐",
    tag: "新作",
    title: "创作歌手方青野时隔三年发新专，首日试听量破纪录",
    summary:
      "专辑主打歌上线不到六小时便冲上多个榜单前三。乐评人评价其「找回初心」，但也有老粉觉得编曲少了一点从前的锐利。",
    time: "5小时前",
    hot: "新",
    views: "52万",
    image:
      "https://readdy.ai/api/search-image?query=artist%20new%20album%20cover%20concept%20with%20vinyl%20record%20and%20handwritten%20lyrics%20sheets%20on%20warm%20wooden%20desk%2C%20indie%20musician%20studio%20ambience%2C%20soft%20candlelight%20glow%2C%20editorial%20music%20photography%20with%20nostalgic%20analog%20feel%20and%20cozy%20tones&width=800&height=500&seq=gd-feed-6&orientation=landscape",
  },
  {
    id: 7,
    categoryKey: "ta",
    category: "塌房",
    tag: "深挖",
    title: "头部带货主播被扒旧直播切片，虚假宣传证据持续发酵",
    summary:
      "有网友整理出多条历年直播对比视频，指出宣传话术与实物不符。平台客服回应正在核查相关商品链接与售后记录。",
    time: "8小时前",
    hot: "热",
    views: "198万",
    image:
      "https://readdy.ai/api/search-image?query=live%20streaming%20studio%20with%20ring%20light%20and%20product%20display%20shelves%20in%20warm%20light%2C%20monitor%20showing%20sharp%20product%20packaging%2C%20contemporary%20ecommerce%20workspace%2C%20editorial%20documentary%20photography%20with%20clean%20warm%20tones%20and%20moderate%20detail&width=800&height=500&seq=gd-feed-7&orientation=landscape",
  },
  {
    id: 8,
    categoryKey: "lian",
    category: "恋情",
    tag: "实锤",
    title: "演员周砚南被拍到与圈内制片人同行，粉丝站集体停更倒计时",
    summary:
      "此次同框画面比以往清晰许多，双方团队目前均保持沉默。部分大粉已发文「心碎停更」，也有路人认为恋爱自由不必上纲上线。",
    time: "11小时前",
    hot: "火",
    views: "77万",
    image:
      "https://readdy.ai/api/search-image?query=two%20figures%20seen%20from%20behind%20walking%20down%20a%20cozy%20city%20street%20in%20the%20evening%2C%20warm%20glowing%20storefront%20windows%2C%20long%20shadows%2C%20cinematic%20candid%20celebrity%20photography%2C%20soft%20warm%20orange%20and%20cream%20color%20palette%2C%20quiet%20intimate%20mood&width=800&height=500&seq=gd-feed-8&orientation=landscape",
  },
  {
    id: 9,
    categoryKey: "fan",
    category: "翻车",
    tag: "热议",
    title: "红毯压轴女星礼服缝线崩开上热搜，造型师深夜发长文道歉",
    summary:
      "礼服在转身瞬间出现状况，摄影师镜头被紧急引导。事后造型师承认赶工失误并致歉，艺人方则大度回应「意外也是美的一部分」。",
    time: "14小时前",
    hot: "爆",
    views: "240万",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20luxurious%20evening%20gown%20fabric%20with%20delicate%20sequins%20and%20draped%20silk%20on%20red%20carpet%2C%20warm%20gold%20spotlight%20reflection%2C%20editorial%20fashion%20detail%20photography%2C%20elegant%20and%20rich%20texture%2C%20soft%20bokeh%20background%20with%20cream%20tones&width=800&height=500&seq=gd-feed-9&orientation=landscape",
  },
];

export interface TimelineEvent {
  time: string;
  category: string;
  text: string;
  detail: string;
}

export const TIMELINE: TimelineEvent[] = [
  {
    time: "09:42",
    category: "塌房",
    text: "某男团成员被曝光深夜私联，公司回应「正在核实」",
    detail: "疑似内部聊天记录流出，多个粉丝站同步发声要求给个说法。",
  },
  {
    time: "09:15",
    category: "恋情",
    text: "陈一一牵手神秘男子逛商场，被镜头全程记录",
    detail: "二人同行画面清晰，男方身份暂未公开。",
  },
  {
    time: "08:58",
    category: "音乐",
    text: "方青野新专辑主打歌上线，试听量一小时破百万",
    detail: "乐迷评价两极，讨论仍在榜单评论区持续。",
  },
  {
    time: "08:30",
    category: "综艺",
    text: "《今天不营业》官宣定档下周五，首期预告释出",
    detail: "预告中嘉宾互怼名场面成为新一轮讨论素材。",
  },
  {
    time: "07:46",
    category: "翻车",
    text: "音乐节现场歌手忘词，全场大合唱成功救场",
    detail: "主办方表示已沟通后续加演事宜，氛围意外很暖。",
  },
  {
    time: "07:05",
    category: "新剧",
    text: "《长安夜雪》片场路透流出，服化道获好评",
    detail: "路透照在剧粉超话迅速刷屏，期待值持续走高。",
  },
];

export const HOT_TOPICS = [
  { rank: 1, title: "颁奖礼红毯名场面大赏", heat: "324万", tag: "爆" },
  { rank: 2, title: "红毯女星礼服崩线全程", heat: "240万", tag: "爆" },
  { rank: 3, title: "头部主播旧切片再发酵", heat: "198万", tag: "热" },
  { rank: 4, title: "音乐节忘词大合唱救场", heat: "132万", tag: "热" },
  { rank: 5, title: "男团成员深夜私联风波", heat: "86万", tag: "热" },
  { rank: 6, title: "周砚南恋情疑云追踪", heat: "77万", tag: "新" },
  { rank: 7, title: "陈一一商场同行对象是谁", heat: "61万", tag: "新" },
  { rank: 8, title: "方青野回归为何引争议", heat: "52万", tag: "新" },
];

export const FEATURES = [
  {
    index: "01",
    title: "造星十年：偶像工业流水线如何批量生产「新瓜」",
    summary:
      "从选秀到成团再到单飞，偶像行业的曝光节奏越来越快，瓜也越来越密。我们梳理了近十年粉丝经济的变化，聊聊为什么「塌房」几乎成为必经之路，以及这场注意力竞赛里，谁在真正受益。",
    readTime: "8 分钟",
    image:
      "https://readdy.ai/api/search-image?query=conceptual%20editorial%20image%20of%20idol%20industry%20with%20backstage%20mirror%20lights%20and%20many%20glowing%20screens%2C%20silhouette%20of%20young%20performer%20in%20center%2C%20warm%20amber%20and%20coral%20neon%20glow%2C%20documentary%20feature%20story%20photography%2C%20layered%20and%20atmospheric%20composition&width=1200&height=800&seq=gd-fea-1&orientation=landscape",
  },
  {
    index: "02",
    title: "一场舆论的兴起与冷却：明星口碑的 72 小时",
    summary:
      "一个热搜的诞生往往只需要一条截图，而口碑的崩塌与修复却要经历漫长的拉扯。从第一波爆料到工作室回应，再到路人反转，我们用时间线复盘一起典型事件的完整生命周期，聊聊舆论场的规律。",
    readTime: "11 分钟",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20concept%20about%20public%20opinion%20cycles%20with%20rising%20and%20falling%20graph%20made%20of%20glowing%20amber%20lines%20over%20warm%20dark%20backdrop%2C%20newspaper%20clippings%20and%20magnifying%20glass%2C%20thoughtful%20journalistic%20photography%2C%20layered%20texture%2C%20warm%20coral%20and%20gold%20palette&width=1200&height=800&seq=gd-fea-2&orientation=landscape",
  },
];

export const FAQS = [
  {
    q: "每日瓜料更新频率是怎样的？",
    a: "每天分早、午、晚三档更新，遇到突发大瓜会第一时间加更。首页的「今日最新」和「刚刚爆」时间线实时刷新，保证大家不用反复刷热搜也能掌握当天发生了什么。",
  },
  {
    q: "页面上的「塌房」「翻车」是什么意思？",
    a: "这两个词是追星圈常用的黑话。塌房指艺人出现人设崩塌的负面消息，翻车泛指现场失误或口碑翻车的情况。栏目把它们单独分类，方便你按兴趣快速筛选想看的瓜。",
  },
  {
    q: "资讯来源可靠吗？会随意造谣吗？",
    a: "我们坚持先求证再发布的原则。每条内容都尽可能附上可查证的时间点、画面或官方口径，存疑消息会明确标注「求证中」，绝不为了流量炮制未经证实的信息。",
  },
  {
    q: "可以投稿爆料或反馈内容问题吗？",
    a: "欢迎通过页脚邮箱与我们联系。投稿需提供尽量完整的时间、地点与线索，我们核实后才会采纳；若发现某条内容有误，也请第一时间告知，我们会在核实后尽快更正或撤下。",
  },
  {
    q: "在哪里能看到此前漏掉的热点？",
    a: "错过更新不要紧，页面下方的「热榜」与「深度专题」会保留近几日讨论度最高的内容，点击即可回溯，不会因为换了一档就错过关键进展。",
  },
];

export const TESTIMONIALS = [
  {
    name: "追星第七年的桃桃",
    role: "忠实读者",
    text: "每天通勤路上刷一遍就能把当天的瓜补完，早午晚三档更新特别适合我这种没空盯热搜的人，节奏刚刚好。",
  },
  {
    name: "互联网冲浪选手",
    role: "路转粉",
    text: "最打动我的是它敢把「求证中」三个字写出来，不跟风带节奏，追得更安心，这才是吃瓜该有的态度。",
  },
  {
    name: "影视区半吊子UP主",
    role: "内容参考",
    text: "写视频脚本经常需要快速梳理事件时间线，这里的复盘分类帮了大忙，来源清晰，引用起来也方便。",
  },
];

export const ABOUT_POINTS = [
  { icon: "ri-timer-flash-line", title: "即时跟进", desc: "早午晚三档滚动更新，突发大瓜第一时间加更，不让你错过任何进展。" },
  { icon: "ri-search-eye-line", title: "先求证再发布", desc: "能查证的标时间，存疑的标注求证中，谣言与事实在页面上写得明明白白。" },
  { icon: "ri-user-voice-line", title: "理性吃瓜", desc: "不放大情绪、不制造对立，用时间线和分类把复杂的热点讲清楚。" },
  { icon: "ri-settings-3-line", title: "开放投稿", desc: "欢迎读者投稿真实线索，我们核实后择优更新，一起维护这片瓜田。" },
];

export const SITE_NAME = "每日瓜料";

// 每条资讯展开阅读时的正文段落（按 id 索引）
export const FEED_DETAILS: Record<number, string[]> = {
  1: [
    "根据网传画面，这名男团成员深夜在市中心某商圈餐厅用餐，同行人数约五到六人。视频拍摄角度较为清晰，成员全程戴着棒球帽与口罩，仅凭身高和走姿被眼尖粉丝认出。",
    "风波发酵后，相关话题两小时内冲上热搜前段。截至目前，所属经纪公司仅表示「正在核实网传内容」，尚未发布正式声明，事件走向仍在持续更新中。",
  ],
  2: [
    "画面显示两人先是在商场一层闲逛，随后进入一家甜品店落座近一小时。期间互动自然，离开时牵手并肩，气氛十分亲昵。",
    "男方身份引发大量猜测，有网友根据穿着与座驾推测其可能是圈外人士。陈一一的社交账号目前暂无更新，工作室也未作出回应。",
  ],
  3: [
    "当晚压轴演出时，这位歌手在副歌部分出现明显忘词，随后音准也出现波动。让观众意外的是，台下几千名歌迷自发打开手机灯光、整齐跟唱，愣是把场面救了回来。",
    "演出结束后，歌手在社交平台发长文自嘲，感谢歌迷「温柔的包容」。评论区画风两极：有人直呼温馨，也有人调侃「以后开演唱会记得带提词器」。",
  ],
  4: [
    "从现场流出的路透照看，《长安夜雪》的置景延续了制作团队一贯偏爱的暖色调质感，宫殿楼阁的配色克制且考究，服化道用料细节也被很多剧评人单独截出来点赞。",
    "目前官方仅确认开机，主演阵容与定妆照尚未正式发布。考虑到剧组此前强调「慢工出细活」，业界普遍预计该剧拍摄周期会偏长，上线时间待定。",
  ],
  5: [
    "据多位参与录制的现场观众透露，节目开场嘉宾自选座位环节就笑料不断，几组艺人的互怼几乎不需要后期剪辑加工，导演组中途多次笑到要求暂停。",
    "节目组随后在官方账号放话，本季主打「去剧本化」的真实互动。首期预告释出后，「敢这么录」的讨论迅速升温，正式播出日期已定在下周五晚。",
  ],
  6: [
    "时隔三年推出的新专辑收录十首作品，其中主打歌延续了他一贯细腻的叙事风格，却在编曲上做了不少减法。首日试听量数据亮眼，多个音乐平台榜单同步登顶。",
    "不过在乐迷群体中也有不同声音：部分老粉觉得比起早期作品少了一丝锐利与棱角。评价虽有分歧，但「终于回归」的期待感仍占据主流。",
  ],
  7: [
    "网友整理的直播切片跨度长达数年，通过多段画面对比，指出主播在推广某些商品时的口头描述与实物存在出入，部分链接的售后处理记录也被一并截出。",
    "目前平台客服回应已介入核查相关商品与历史直播内容。由于涉及消费权益，事件的讨论已从「吃瓜」蔓延到更广泛的购物场景，关注度仍在攀升。",
  ],
  8: [
    "此次同框画面拍摄于晚间，清晰度明显高于此前多次被拍到的模糊版本，因此粉丝辨认基本没有分歧。两人交谈熟络，疑为工作以外的私交。",
    "面对外界关注，双方团队保持沉默。一方面有粉丝表示尊重艺人私人生活，另一方面多家粉丝站已陆续挂出「暂停更新」的公告，情绪仍在发酵。",
  ],
  9: [
    "颁奖礼红毯进行到压轴环节时，这名女星转身向镜头挥手，礼服侧腰处的缝线突然出现明显崩开。现场摄影师反应迅速，镜头很快被引向其他方向，未造成更大尴尬。",
    "凌晨，负责该套礼服的造型团队发布长文致歉，承认因赶工导致走线强度不足。艺人方随后暖心回应，称「意外也是今晚美的一部分」，话题虽在热搜但整体氛围偏暖。",
  ],
};